import React, { useMemo } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import About from './pages/About';
import Books from './pages/Books';
import Contact from './pages/Contact';

function App() {
  const fireflies = useMemo(() => {
    // Create a grid for more uniform distribution
    const gridSize = 5; // 5x5 grid
    const cellWidth = 100 / gridSize;
    const cellHeight = 100 / gridSize;
    
    return Array.from({ length: 20 }).map((_, index) => {
      // Distribute across grid cells
      const gridRow = Math.floor(index / gridSize);
      const gridCol = index % gridSize;
      
      // Add some randomness within each grid cell
      const top = `${gridRow * cellHeight + (Math.random() * 0.6 + 0.2) * cellHeight}%`;
      const left = `${gridCol * cellWidth + (Math.random() * 0.6 + 0.2) * cellWidth}%`;
      const delay = `${(Math.random() * 2).toFixed(2)}s`;
      const duration = `${(3 + Math.random() * 40).toFixed(2)}s`;
      const swirl = Math.random() > 0.9; // ~40% swirl
      return { top, left, delay, duration, swirl };
    });
  }, []);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isAbout = location.pathname === '/about';
  const isBooks = location.pathname === '/books';
  const isContact = location.pathname === '/contact';

  return (
    <>
      <nav style={{ backgroundColor: isHome ? 'transparent' : undefined }}>
        <div className="container header-container">
          <Link to="/" className={isHome ? 'active' : ''}>Home</Link>
          <Link to="/about" className={isAbout ? 'active' : ''}>About</Link>
          <Link to="/books" className={isBooks ? 'active' : ''}>Books</Link>
          <Link to="/contact" className={isContact ? 'active' : ''}>Contact</Link>
        </div>
        {fireflies.map((pos, idx) => (
          <span
            key={idx}
            className={`firefly${pos.swirl ? ' swirl' : ''}`}
            style={{
              top: pos.top,
              left: pos.left,
              animationDelay: pos.delay,
              animationDuration: pos.duration,
              opacity: 0.1
            }}
          />
        ))}
      </nav>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/books" element={<Books />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App; 